import * as Popup from "./components/popup";
import * as Component from "./component";
import * as UI from "./ui";

document.addEventListener("DOMContentLoaded", () => {
  UI.onDataActionClick("zoom:toggle", ({ target }) => {
    const popupEl = Component.getExtra(target, "popupEl");

    if (popupEl) {
      Popup.close(popupEl);
    } else {
      zoom(target);
    }
  });
});

function zoom(zoomContentEl) {
  createAndAddPlaceholder(zoomContentEl);

  const popupEl = Popup.create(zoomContentEl, zoomContentEl.parentElement, "popup--zoomed-content");

  toggleContent(zoomContentEl, true);

  popupEl.addEventListener(
    "close",
    () => {
      unzoom(zoomContentEl);
    },
    { once: true }
  );
}

function unzoom(zoomContentEl) {
  const containerEl = Component.popExtra(zoomContentEl, "containerEl");
  deletePlaceholder(containerEl);
  containerEl.appendChild(zoomContentEl);

  Popup.destroy(zoomContentEl);

  toggleContent(zoomContentEl, false);
}

/**
 * Show / hide maximize / minimize icons and any html element using `data-zoomed-hidden` attribute.
 *
 * @param {HTMLElement} zoomContentEl
 * @param {boolean} zoomed
 */
function toggleContent(zoomContentEl, zoomed) {
  const minimizeIcon = zoomContentEl.querySelector(".js-minimize");
  const maximizeIcon = zoomContentEl.querySelector(".js-maximize");

  Array.from(zoomContentEl.querySelectorAll("[data-zoomed-hidden]")).forEach((n) => n.classList.toggle("hidden", zoomed));

  minimizeIcon.classList.toggle("hidden", !zoomed);
  maximizeIcon.classList.toggle("hidden", zoomed);
}

/**
 * Create a placeholder in place of the element that will be moved to the popup.
 * It avoids the page scrolling underneath the dialog.
 *
 * @param {HTMLElement} zoomContentEl
 */
function createAndAddPlaceholder(zoomContentEl) {
  const containerEl = zoomContentEl.parentElement;

  const placeholderEl = document.createElement("div");
  placeholderEl.classList.add("js-zoomed-content-placeholder");
  placeholderEl.style.height = zoomContentEl.offsetHeight + "px";
  placeholderEl.style.width = zoomContentEl.offsetWidth + "px";

  containerEl.appendChild(placeholderEl);
}

function deletePlaceholder(containerEl) {
  containerEl.querySelector(".js-zoomed-content-placeholder").remove();
}
